export const FENCE_TYPES = [
    {type: "Project", label: "Project", icon: "mdi-chart-gantt"},
    {type: "Workplace", label: "Workplace", icon: "mdi-office-building-marker"},
    {type: "CostCenter", label: "Cost center", icon: "mdi-tag"},
    {type: "User", label: "User", icon: "mdi-account"},
    {type: "Resource", label: "Resource", icon: "mdi-toolbox"},
]
export default FENCE_TYPES
